import { render, staticRenderFns } from "./AdminQA.vue?vue&type=template&id=cb8bbde2"
import script from "./AdminQA.vue?vue&type=script&lang=js"
export * from "./AdminQA.vue?vue&type=script&lang=js"
import style0 from "./AdminQA.vue?vue&type=style&index=0&id=cb8bbde2&prod&lang=scss"
import style1 from "./AdminQA.vue?vue&type=style&index=1&id=cb8bbde2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports